export const content = {
  title : "Free Seminars",
  subtitle: "Experience instruction from industry professionals prior to any commitment",
  imageUrl: "./assets/PFDcloseUp.jpg",
  imageAlt: "G1000 PFD Close Up"
}